import { KeyboardEventHandler, RefObject, useState } from 'react'

import { FireAccordionItem } from './FireAccordionItem'

const ARROW_UP = 'ArrowUp'
const ARROW_DOWN = 'ArrowDown'

export const FireAccordion = ({
  items,
  showDivider,
  expandIcon,
}: AccordionProps) => {
  const [sectionExpandedState, setSectionExpandedState] = useState<boolean[]>(
    new Array(items.length).fill(false)
  )

  const setIsExpanded = (index: number) => (value: boolean) => {
    const newExpandedState = [...sectionExpandedState]
    newExpandedState[index] = value
    setSectionExpandedState(newExpandedState)
  }

  const sectionKeyDown: (
    index: number
  ) => KeyboardEventHandler<HTMLButtonElement> = (index) => (e) => {
    if (e.key !== ARROW_DOWN && e.key !== ARROW_UP) return

    e.preventDefault()

    if (e.key === ARROW_DOWN && index < items.length - 1) {
      items[index + 1].ref.current?.focus()
    }

    if (e.key === ARROW_UP && index !== 0) {
      items[index - 1].ref.current?.focus()
    }
  }

  return (
    <ul>
      {items.map((item, index) => (
        <FireAccordionItem
          key={`${item.id}-${index}`}
          id={item.id}
          title={item.title}
          index={index}
          isExpanded={sectionExpandedState[index]}
          setIsExpanded={setIsExpanded(index)}
          sectionRef={item.ref}
          sectionKeyDown={sectionKeyDown}
          showDivider={showDivider}
          expandIcon={expandIcon}
        >
          {item.children}
        </FireAccordionItem>
      ))}
    </ul>
  )
}

export interface AccordionProps {
  items: {
    id: string
    title: string | JSX.Element
    ref: RefObject<HTMLButtonElement>
    children: JSX.Element
  }[]
  showDivider?: boolean
  expandIcon?: 'chevron' | 'symbols'
}
